<template>
  <div id="main" class="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  /* background: #f0f0f0; */
  /* overflow: hidden; */
}

.app-main {
  width: 100%;
  height: 100%;
  margin-top: -0.22rem;
  padding-top: .22rem;
  /* background-color: #fdebd9; */
}
#cnzz_stat_icon_1279006663 {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue